import React, { useEffect, useReducer, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import { Routes } from "../../../routes";

export const Context = React.createContext(null);

const getDefaultStatusFromPath = (pathname) => {
  if (pathname === Routes.VietlottGroupPending?.path || pathname?.endsWith('/group/pending')) return 0;
  if (pathname === Routes.VietlottGroupActive?.path || pathname?.endsWith('/group/active')) return 1;
  if (pathname === Routes.VietlottGroupCompleted?.path || pathname?.endsWith('/group/completed')) return 'completed';
  if (pathname === Routes.VietlottGroupRewarded?.path || pathname?.endsWith('/group/rewarded')) return 4;
  if (pathname === Routes.VietlottGroupCancelled?.path || pathname?.endsWith('/group/cancelled')) return 3;
  return '';
};

const initialFilterData = {
  createdFrom: null,
  createdTo: null,
  activatedFrom: null,
  activatedTo: null,
  completedFrom: null,
  completedTo: null,
  canceledFrom: null,
  canceledTo: null,
  rewardedFrom: null,
  rewardedTo: null,
  gameId: '',
  phone: '',
  cartGroupId: '',
  status: ''
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        ...action.payload
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {
  const location = useLocation();
  const defaultStatus = getDefaultStatusFromPath(location.pathname);
  const [state, dispatch] = useReducer(reducer, { ...initialFilterData, status: defaultStatus });
  const tableRef = useRef(null);

  useEffect(() => {
    const statusFromPath = getDefaultStatusFromPath(location.pathname);
    // Always update when path changes and status is different
    if (state.status !== statusFromPath) {
      dispatch({ type: 'SUBMIT_FILTER', payload: { ...initialFilterData, status: statusFromPath } });
    }
  }, [location.pathname]);

  useEffect(() => {
    document.title = "Mua chung"
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <br />

      <Table ref={tableRef} />
    </Context.Provider>
  );
};
